// Cambridge A2 Flyers vocab.js — Week 33
export default {
  vocab: [
  {
    "word": "corridor",
    "definition_en": "a long passage in a building with doors on each side",
    "definition_vi": "hành lang",
    "example": "Walk carefully down the school corridor.",
    "ipa": "/ˈkɒr.ɪ.dɔːr/"
  },
  {
    "word": "slipped",
    "definition_en": "slid accidentally and lost balance",
    "definition_vi": "trượt ngã",
    "example": "He slipped on the wet floor near the stairs.",
    "ipa": "/slɪpt/"
  },
  {
    "word": "bandage",
    "definition_en": "a strip of cloth used to bind a wound or injury",
    "definition_vi": "băng y tế",
    "example": "The nurse applied a clean bandage to his knee.",
    "ipa": "/ˈbæn.dɪdʒ/"
  },
  {
    "word": "nurse",
    "definition_en": "a person trained to care for sick or injured people",
    "definition_vi": "y tá",
    "example": "The school nurse treated the boy gently.",
    "ipa": "/nɜːs/"
  },
  {
    "word": "emergency",
    "definition_en": "a serious, unexpected, and dangerous situation",
    "definition_vi": "tình huống khẩn cấp",
    "example": "Call the nurse in an emergency.",
    "ipa": "/ɪˈmɜː.dʒən.si/"
  },
  {
    "word": "cautiously",
    "definition_en": "in a careful way to avoid danger or mistakes",
    "definition_vi": "cẩn trọng",
    "example": "Students walked cautiously on the wet grass.",
    "ipa": "/ˈkɔː.ʃəs.li/"
  },
  {
    "word": "warning",
    "definition_en": "a statement or sign telling someone of potential danger",
    "definition_vi": "cảnh báo",
    "example": "Look at the yellow warning sign on the floor.",
    "ipa": "/ˈwɔː.nɪŋ/"
  },
  {
    "word": "bleeding",
    "definition_en": "losing blood from the body due to injury",
    "definition_vi": "chảy máu",
    "example": "The cut on his knee stopped bleeding quickly.",
    "ipa": "/ˈbliː.dɪŋ/"
  },
  {
    "word": "headmaster",
    "definition_en": "the principal teacher in charge of a school",
    "definition_vi": "thầy hiệu trưởng",
    "example": "The headmaster praised Jake for his fast reaction.",
    "ipa": "/ˌhedˈmɑː.stər/"
  },
  {
    "word": "relieved",
    "definition_en": "feeling relaxed because something bad has stopped",
    "definition_vi": "nhẹ nhõm",
    "example": "Everyone felt relieved when the boy smiled again.",
    "ipa": "/rɪˈliːvd/"
  },
  {
    "word": "hesitation",
    "definition_en": "the action of pausing before saying or doing something",
    "definition_vi": "sự do dự",
    "example": "Jake helped him without any hesitation.",
    "ipa": "/ˌhez.ɪˈteɪ.ʃən/"
  },
  {
    "word": "injure",
    "definition_en": "to harm or damage a person physically",
    "definition_vi": "làm bị thương",
    "example": "Be careful so you do not injure your leg.",
    "ipa": "/ˈɪn.dʒər/"
  },
  {
    "word": "first-aid",
    "definition_en": "help given to a sick or injured person before medical care",
    "definition_vi": "sơ cứu",
    "example": "The nurse brought a complete first-aid kit.",
    "ipa": "/ˌfɜːst ˈeɪd/"
  },
  {
    "word": "slippery",
    "definition_en": "difficult to hold or stand on because it is wet or smooth",
    "definition_vi": "trơn trượt",
    "example": "The wet wooden floor was very slippery.",
    "ipa": "/ˈslɪp.ər.i/"
  },
  {
    "word": "stumble",
    "definition_en": "to trip or lose balance while walking",
    "definition_vi": "vấp ngã",
    "example": "Watch your step so you do not stumble.",
    "ipa": "/ˈstʌm.bəl/"
  },
  {
    "word": "prevent",
    "definition_en": "to stop something from happening or arising",
    "definition_vi": "ngăn ngừa",
    "example": "Walking slowly helps prevent accidents.",
    "ipa": "/prɪˈvent/"
  },
  {
    "word": "rules",
    "definition_en": "instructions telling people what they must or must not do",
    "definition_vi": "quy tắc",
    "example": "Always obey the school safety rules.",
    "ipa": "/ruːlz/"
  },
  {
    "word": "calmly",
    "definition_en": "in a quiet and relaxed manner without excitement",
    "definition_vi": "bình tĩnh",
    "example": "Jake spoke calmly to the injured student.",
    "ipa": "/ˈkɑːm.li/"
  },
  {
    "word": "responsibly",
    "definition_en": "in a sensible and trustworthy manner",
    "definition_vi": "có trách nhiệm",
    "example": "Act responsibly when helping younger children.",
    "ipa": "/rɪˈspɒn.sə.bli/"
  },
  {
    "word": "attention",
    "definition_en": "notice taken of someone or something",
    "definition_vi": "sự chú ý",
    "example": "Pay close attention to warning signs.",
    "ipa": "/əˈten.ʃən/"
  }
]
};
